import Vue from 'vue'
import Vuex from 'vuex'

import App from './App.vue'
import store from './store'
import questions from './data/questions' // Manually loading the questions


Vue.config.productionTip = false
Vue.use(Vuex)

new Vue({
  render: h => h(App),
  store,
  mounted () { // Added functionality
    this.$store.commit('setUnanswered', questions)
    this.$store.dispatch('init')
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js